import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import Loader from '@/components/Loader.tsx';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useAuthenticationDataContext } from '@/utils/providers/authetnitactionDataContext/useAuthenticationDataContext.tsx';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import WelcomeAdminPage from '@/views/welcome/pages/WelcomeAdmin.page.tsx';
import WelcomeAgainPage from '@/views/welcome/pages/WelcomeAgain.page.tsx';
import WelcomeFirstPage from '@/views/welcome/pages/WelcomeFirst.page.tsx';
import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { useLogin } from './util/useLogin.util';

const PARAMS = {
  ADMIN: 'admin',
  BACK: 'back',
  FIRST: 'first',
};
export const LoginView: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.login');
  const { isPending, loginOtt } = useLogin();
  const { setAuthenticationData } = useAuthenticationDataContext();
  const queryClient = useQueryClient();
  const { setIsInitialized, user } = useUserContext();
  const currentUrl = window.location.href;
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(RoutesEnum.ROOT);
    }
  }, [navigate, user]);

  const handleInit = async () => {
    const match = /\/login\/([^?]+)/.exec(currentUrl);
    const token = match ? match[1] : null;

    if (!currentUrl.includes('/login/') || !token) {
      toast.error(t('toast.unknownError'));
      throw new Error('Token is not provided');
    }

    const authentication = await loginOtt({ token });
    if (!authentication) {
      toast.error(t('toast.loginError'));
      return;
    }
    window.location.href = window.location.origin + RoutesEnum.ROOT;
    setAuthenticationData(authentication);
    setIsInitialized(false);
    await queryClient.refetchQueries({ queryKey: [QueryKeyEnum.GET_CURRENT_USER] });
  };

  const paramMatch = /\?(\w+)$/.exec(currentUrl);
  const param = paramMatch ? paramMatch[1] : null;
  const ComponentToRender =
    (!param && WelcomeFirstPage) ||
    (param === PARAMS.BACK && WelcomeAgainPage) ||
    (param === PARAMS.ADMIN && WelcomeAdminPage) ||
    WelcomeFirstPage;

  if (isPending) {
    return <Loader className="min-h-dvh" />;
  }

  return <ComponentToRender onClick={handleInit} />;
};
